import { FaCheckCircle, FaTimes } from "react-icons/fa";
import { testStates } from "../../installationTypes"
import { FieldButton, ResultContainer, ResultValue } from "../styling/FieldStyles"

const FieldTestResult = ({ disabled, state, testResult, close}) => {
    return <>
        {!disabled && (state !== testStates.NONE) ? <>
            <ResultContainer>
                <div>
                    {state === testStates.SUCCESS ? <>
                        <span>
                            <ResultValue>
                                <FaCheckCircle />
                                <span>Value: </span>
                                <span>{testResult}</span>
                            </ResultValue>
                        </span>
                    </> : <></>}


                    <span>
                        {state === testStates.FAILED ? <>
                            Failed<span>: {testResult}</span>
                        </> : <></>}
                    </span>

                    <span>
                        {state === testStates.TESTING ? <>
                            Testing...
                        </> : <></>}
                    </span>
                </div>
                <div>
                    <FieldButton onClick={close}>
                        <FaTimes />
                    </FieldButton>
                </div>
            </ResultContainer>
        </> : <></>}
    </>
}

export default FieldTestResult;